/**
 * DOC-AUDIT-1 S2 — the document beacon, CORE half: ZERO imports.
 *
 * Some exports never send their bytes through the server (the library CSV template, the family fee print,
 * the two share cards), so the browser reports them. This half only hands the event to a registered
 * sender. It imports nothing on purpose, exactly like `usage-core.ts`: the share helpers that call it are
 * bundled by Chromium probes, and a module that pulled `services/api` in would drag axios and the auth
 * stack into those bundles and into the scripts compile graph. The sender that owns the network call lives
 * in `./document-beacon` and installs itself from `main.tsx`.
 *
 * Fire-and-forget by construction: a missing sender, a throwing sender or a failed request can never block
 * or fail the export it reports.
 */
export type DocumentBeaconType = 'LIBRARY_CSV' | 'FEE_FAMILY_PRINT' | 'OCCASION_CARD_SHARE' | 'OLYMPIAD_SHARE_CARD';

export interface DocumentBeacon {
  documentType: DocumentBeaconType;
  studentId?: string;
  classId?: string;
  filename?: string;
  bytes?: number;
}

type Sender = (beacon: DocumentBeacon) => void;
let sender: Sender | null = null;

export function setDocumentBeaconSender(next: Sender | null): void {
  sender = next;
}

export function recordDocumentBeacon(beacon: DocumentBeacon): void {
  try {
    sender?.(beacon);
  } catch {
    /* never block or fail the export being reported */
  }
}
